import React from 'react'

import { Chart } from './chart'

export const ChartTable = (args) => {

    return <Chart {...args} />
}